import { makeStyles } from "@mui/styles"

const useStyles = makeStyles(() => ({
    titleBox: {
        fontWeight: 600,
        fontStyle: 'normal',
        letterSpacing: '0px',
        color: '#69716F',
        opacity: 1,
    },
    contentBox: {
        '@media (min-width:580px)': {
            // eslint-disable-line no-useless-computed-key
            textAlign: 'left',
        },
        textAlign: 'center',
        paddingLeft: '8px',
        paddingTop: '8px',
        fontSize: '1.125rem',
    },
    contentBoxExtraPadding: {
        '@media (min-width:580px)': {
            // eslint-disable-line no-useless-computed-key
            textAlign: 'left',
        },
        textAlign: 'center',
        paddingLeft: '8px',
        paddingTop: '16px',
        fontSize: '1.125rem',
    },
    imageBox: {
        '@media (min-width:580px)': {
            // eslint-disable-line no-useless-computed-key
            textAlign: 'right',
        },
        textAlign: 'center',
    },
    link: {
        color: '#3B86FC',
        fontSize: '20px',
    },
}))

export default useStyles
